module.exports = __webpack_public_path__ + "img/lifestyle.31c2f929.svg";